import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LoadingService } from '../loading.service';

@Component({
  selector: 'full-page-spinner',
  templateUrl: './full-page-spinner.component.html'
})
export class FullPageSpinnerComponent implements OnInit {

  public isBusy = false;

  constructor(private loadingService: LoadingService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.loadingService.loading$.subscribe(showBusySpinner => {
      this.isBusy = showBusySpinner;
      this.cdr.detectChanges();
    });
  }
}
